module.exports = __webpack_public_path__ + "img/chrome.287480d3.png";